import { DirectionsRenderer } from "@react-google-maps/api";
import GoogleMapReact from "google-map-react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { GiConsoleController } from "react-icons/gi";
import Map from "../../common/MapComponent/Map";
import MapStyle from "../../common/MapComponent/MapStyle";
import originImage from "../../../static/icons/map_icon/png/002-location-pin.png";
import chargingImage from "../../../static/icons/map_icon/png/001-charging-station.png";
import destinationImage from "../../../static/icons/map_icon/png/003-placeholder.png";
import { MdOutlineBackHand } from "react-icons/md";
import UserContext from "../../../Context/UserProvider";
import { Box, Typography, Stack } from "@mui/material";

let markers: google.maps.Marker[] = [];
function MapWithRoute(props: any) {
  const {userInfo, setUserInfo} = useContext(UserContext);
  let originIcon = process.env.NODE_ENV === "production" ? process.env.REACT_APP_CDN_URL + "/static/icons/map_icon/png/00222-location-pin.png" : originImage;
  let destinationIcon = process.env.NODE_ENV === "production" ? process.env.REACT_APP_CDN_URL + "/static/icons/map_icon/png/003-placeholder.png" : destinationImage;
  let chargingIcon = process.env.NODE_ENV === "production" ? process.env.REACT_APP_CDN_URL + "/static/icons/map_icon/png/001-charging-station.png" : chargingImage;
  const [error, setError] = useState() as any;
  const directionsDisplay = useRef(null);
  const [roadResult, setRoadResult] = useState() as any;
  const [map, setMap] = useState() as any;
  const [maps, setMaps] = useState() as any;
  const distance = props.selectedDistance;
  const places = props.data[props.selectedJourney].map((e: any) => ({ ...e, lat: +e.latLong.split(",")[0], lng: +e.latLong.split(",")[1] }));
  const defaultProps = {
    center: {
      lat: 53.40979,
      lng: -2.15761,
    },
    zoom: 7,
  };
  let waypts: google.maps.DirectionsWaypoint[] = [];
  const waypoints: any = places.map((p: any) => ({
    location: { lat: p.lat, lng: p.lng, chargePoint: p.chargePoint },
    isWayPoints: !(p.type === "RE_ROUTE"),
    stopover: p.type === "CHARGE_POINT",
  }));

  for (let i = 1; i < waypoints.length - 1; i++) {
    waypoints[i].isWayPoints && waypts.push({ location: waypoints[i].location, stopover: waypoints[i].stopover });
  }
  const origin = waypoints[0].location;
  const destination = waypoints[waypoints.length - 1].location;

  let infoMarker = (markerInfo: any) => {
    // Check for additional properties that might be available
    const hasAddress = markerInfo.properties.address || markerInfo.properties.addressLine;
    const hasBusiness = markerInfo.properties.businessName || markerInfo.properties.business;
    const hasAvailability = markerInfo.properties.available || markerInfo.properties.availability;
    const hasStatus = markerInfo.properties.status || markerInfo.properties.chargePointConnectorStatus;
    const hasIdentifier = markerInfo.properties.chargePointIdentifier || markerInfo.properties.identifier;
    
    return new google.maps.InfoWindow({
      content: `
      <div style="
        padding: 16px;
        font-family: 'Roboto', sans-serif;
        max-width: 350px;
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      ">
        <div style="
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          padding-bottom: 8px;
          border-bottom: 2px solid #4CAF50;
        ">
          <div style="
            width: 24px;
            height: 24px;
            background: #4CAF50;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 8px;
          ">
            <span style="color: white; font-size: 14px; font-weight: bold;">⚡</span>
          </div>
          <h3 style="margin: 0; color: #333; font-size: 16px; font-weight: 600;">
            Charging Station
          </h3>
        </div>
        
        <div style="display: flex; flex-direction: column; gap: 8px;">
          <div style="
            display: flex;
            justify-content: space-between;
            padding: 4px 0;
            border-bottom: 1px solid #f0f0f0;
          ">
            <span style="font-weight: 500; color: #666;">Location:</span>
            <span style="color: #333;">${markerInfo.properties.label}</span>
          </div>
          
          ${hasAddress ? `
          <div style="
            display: flex;
            justify-content: space-between;
            padding: 4px 0;
            border-bottom: 1px solid #f0f0f0;
          ">
            <span style="font-weight: 500; color: #666;">Address:</span>
            <span style="color: #333; text-align: right; max-width: 200px;">${markerInfo.properties.address || markerInfo.properties.addressLine}</span>
          </div>
          ` : ''}
          
          ${hasBusiness ? `
          <div style="
            display: flex;
            justify-content: space-between;
            padding: 4px 0;
            border-bottom: 1px solid #f0f0f0;
          ">
            <span style="font-weight: 500; color: #666;">Business:</span>
            <span style="color: #333;">${markerInfo.properties.businessName || markerInfo.properties.business}</span>
          </div>
          ` : ''}
          
          ${hasIdentifier ? `
          <div style="
            display: flex;
            justify-content: space-between;
            padding: 4px 0;
            border-bottom: 1px solid #f0f0f0;
          ">
            <span style="font-weight: 500; color: #666;">ID:</span>
            <span style="color: #666; font-family: monospace; font-size: 12px;">${markerInfo.properties.chargePointIdentifier || markerInfo.properties.identifier}</span>
          </div>
          ` : ''}
          
          <div style="
            display: flex;
            justify-content: space-between;
            padding: 4px 0;
            border-bottom: 1px solid #f0f0f0;
          ">
            <span style="font-weight: 500; color: #666;">Connector:</span>
            <span style="color: #333;">${markerInfo.properties.connectorUsed.connectorType}</span>
          </div>
          
          <div style="
            display: flex;
            justify-content: space-between;
            padding: 4px 0;
            border-bottom: 1px solid #f0f0f0;
          ">
            <span style="font-weight: 500; color: #666;">Rate:</span>
            <span style="color: #4CAF50; font-weight: 600;">${markerInfo.properties.connectorUsed.rateKW} kW</span>
          </div>
          
          <div style="
            display: flex;
            justify-content: space-between;
            padding: 4px 0;
            border-bottom: 1px solid #f0f0f0;
          ">
            <span style="font-weight: 500; color: #666;">Power Type:</span>
            <span style="color: #333;">${markerInfo.properties.connectorUsed.powerType}</span>
          </div>
          
          ${hasAvailability ? `
          <div style="
            display: flex;
            justify-content: space-between;
            padding: 4px 0;
            border-bottom: 1px solid #f0f0f0;
          ">
            <span style="font-weight: 500; color: #666;">Availability:</span>
            <span style="color: #4CAF50; font-weight: 600;">${markerInfo.properties.available || markerInfo.properties.availability}</span>
          </div>
          ` : ''}
          
          ${hasStatus ? `
          <div style="
            display: flex;
            justify-content: space-between;
            padding: 4px 0;
          ">
            <span style="font-weight: 500; color: #666;">Status:</span>
            <span style="
              color: ${(markerInfo.properties.status || markerInfo.properties.chargePointConnectorStatus) === 'AVAILABLE' ? '#4CAF50' : '#FF5722'}; 
              font-weight: 600;
            ">${markerInfo.properties.status || markerInfo.properties.chargePointConnectorStatus}</span>
          </div>
          ` : ''}
        </div>
      </div>
      `,
    });
  };

  function handleApiLoaded(map: any, maps: any) {
    var icons = {
      start: new maps.MarkerImage(
        originIcon,
        new google.maps.Size(40, 40),
        new google.maps.Point(0, 0),
        new google.maps.Point(20, 40)
      ),
      end: new maps.MarkerImage(
        destinationIcon,
        new google.maps.Size(40, 40),
        new google.maps.Point(0, 0),
        new google.maps.Point(20, 40)
      ),
      charge: new maps.MarkerImage(
        chargingIcon,
        new google.maps.Size(45, 45),
        new google.maps.Point(0, 0),
        new google.maps.Point(22, 45)
      ),
      waypoints: new maps.MarkerImage(
        "http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=1|FF6B35|FFFFFF",
        new google.maps.Size(35, 35),
        new google.maps.Point(0, 0),
        new google.maps.Point(17, 35)
      ),
    };

    function addMarker(position: any, icon: any, title: any, chargingStation: boolean, map: any) {
      const marker = new maps.Marker({
        position: position,
        map: map,
        icon: icon,
        // title: title,
      });
      if (chargingStation) {
        const markerInfo = infoMarker(position.chargePoint);
        
        // Open info window on mouseover
        google.maps.event.addListener(marker, "mouseover", function () {
          markerInfo.open(map, marker);
        });
        
        // Close info window on mouseout
        google.maps.event.addListener(marker, "mouseout", function () {
          markerInfo.close();
        });
      }
      markers.push(marker);
    }
    function setMapOnAll(map: google.maps.Map | null) {
      for (let i = 0; i < markers.length; i++) {
        markers[i].setMap(map);
      }
    }
    // Removes the markers from the map, but keeps them in the array.
    function hideMarkers(): void {
      setMapOnAll(null);
    }
    function deleteMarkers(): void {
      hideMarkers();
      markers = [];
    }
    deleteMarkers();
    addMarker(origin, icons.start, "start", false, map);
    addMarker(destination, icons.end, "start", false, map);
    let wayIndex = 1;
    waypts.map((location: any, index: any) => {
      if (!location.stopover) {
        addMarker(
          location.location,
          new maps.MarkerImage(
            `http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=${wayIndex}|FF6B35|FFFFFF`,
            new google.maps.Size(40, 40),
            new google.maps.Point(0, 0),
            new google.maps.Point(20, 40)
          ),
          "enroute location",
          false,
          map
        );
        wayIndex++;
      }
    });

    waypts.map((location: any) => {
      location.stopover && addMarker(location.location, icons.charge, "charging station", true, map);
    });

    // Enhanced route line styling
    var lineSymbol = {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      fillColor: "#4CAF50",
      fillOpacity: 1,
      strokeColor: "#2E7D32",
      strokeWeight: 2,
      scale: 4,
    };

    var polylineDotted = {
      strokeColor: "#4CAF50",
      strokeOpacity: 0.8,
      fillOpacity: 0,
      strokeWeight: 6,
      icons: [
        {
          icon: lineSymbol,
          offset: "50%",
          repeat: "100px",
        },
      ],
    };

    var rendererOptions = {
      map: map,
      suppressMarkers: true,
      polylineOptions: polylineDotted,
    };
    // Use the newer Routes API (recommended) or fallback to Directions API
    let directionsService;
    try {
      // Try to use Routes API first (newer, more features)
      directionsService = new (window as any).google.maps.RoutesService();
    } catch (error) {
      // Fallback to Directions API if Routes API is not available
      directionsService = new maps.DirectionsService();
    }
    
    if (directionsDisplay.current === null) {
      directionsDisplay.current = new maps.DirectionsRenderer(rendererOptions);
    }
    
    function secondsToTime(secs: any) {
      var hours = Math.floor(secs / (60 * 60));
      var divisor_for_minutes = secs % (60 * 60);
      var minutes = Math.floor(divisor_for_minutes / 60);
      var divisor_for_seconds = divisor_for_minutes % 60;
      var seconds = Math.ceil(divisor_for_seconds);
      var obj = {
        h: hours,
        m: minutes,
        s: seconds,
      };
      var result = obj.h.toString() + " hour " + obj.m.toString() + " mins";
      return result;
    }
    
    const directionDisplay = directionsDisplay.current as any;
    directionDisplay.setMap(map);
    
    // Prepare route request parameters
    const routeRequest = {
      origin: origin,
      destination: destination,
      travelMode: google.maps.TravelMode.DRIVING,
      drivingOptions: {
        departureTime: new Date(Date.now()),
        trafficModel: "optimistic",
      },
      provideRouteAlternatives: false,
      waypoints: waypts,
      region: "GB",
    };
    
    directionsService.route(
      routeRequest,
      (result: any, status: any) => {
        if (status === "OK") {
          directionDisplay.setDirections(result);
          let distance = 0;
          let travelTime = 0;
          result.routes[0].legs.map((e: any) => {
            distance = distance + e.distance.value;
            travelTime = travelTime + e.duration.value;
          });
          setRoadResult({ 
            distance: Math.round(distance / 1000).toString() + " km", 
            duration: secondsToTime(travelTime) 
          });
        } else {
          directionDisplay.setMap(null);
          setError(result);
          console.error("Route API error:", status, result);
        }
      }
    );
  }
  useEffect(() => {
    map && maps && handleApiLoaded(map, maps);
    // handleApiLoaded(map, maps)
  }, [props.selectedJourney, map, maps]);

  return (
    <Box sx={{ 
      width: '100%', 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column',
      position: 'relative',
      '& .google-map': {
        width: '100% !important',
        height: 'calc(100% - 40px) !important',
      }
    }}>


      <Box sx={{ flexGrow: 1, minHeight: 0 }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAP_KEY as string }}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
          options={{ 
            styles: MapStyle.light,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true
          }}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => (setMap(map), setMaps(maps))}
        />
      </Box>
      {roadResult && (
        <Stack 
          direction="row" 
          justifyContent="space-around" 
          alignItems="center"
          sx={{ 
            py: 2,
            px: 3,
            backgroundColor: 'background.paper',
            borderTop: 2,
            borderColor: 'primary.main',
            boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
            borderRadius: '8px 8px 0 0'
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
              Total Distance
            </Typography>
            <Typography variant="h6" color="primary.main" sx={{ fontWeight: 600 }}>
              {parseInt(distance).toLocaleString()} {userInfo.userProfile.distanceUnitShortDisplayName}
            </Typography>
          </Box>
          
          <Box sx={{ 
            width: 1, 
            height: 40, 
            backgroundColor: 'divider',
            mx: 2
          }} />
          
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
              Travel Time
            </Typography>
            <Typography variant="h6" color="primary.main" sx={{ fontWeight: 600 }}>
              {roadResult?.duration}
            </Typography>
          </Box>
        </Stack>
      )}
    </Box>
  );
}

export default MapWithRoute;
